import { filterProducts, sortProducts } from "./products/filterSort";
import { getCategories, productData } from "./products/data";
import { readStateFromQuery, writeStateToQuery } from "./state/queryState";
import { renderCards } from "./ui/cards";
import { renderFilterPanel } from "./ui/filterPanel";
import type { SortOption } from "./products/types";

export function renderApp(root: HTMLElement): void {
  const categories = getCategories(productData);
  const queryState = readStateFromQuery(categories);

  root.innerHTML = `
    <section class="container" aria-labelledby="test-heading">
      <header class="hero">
        <p class="kicker">Stiftung Warentest</p>
        <h1 id="test-heading">Produktvergleich Testergebnisse</h1>
        <p>Vergleichen Sie Testergebnisse von Saugrobotern und finden Sie passende Produkte schnell per Filter und Sortierung.</p>
      </header>
      ${renderFilterPanel(categories, queryState)}

      <p class="result-count" aria-live="polite"></p>
      <div id="results" class="results" tabindex="-1"></div>
    </section>
  `;

  const categoryFilter = root.querySelector<HTMLSelectElement>("#categoryFilter");
  const maxOverall = root.querySelector<HTMLSelectElement>("#maxOverall");
  const sortBy = root.querySelector<HTMLSelectElement>("#sortBy");
  const resultCount = root.querySelector<HTMLElement>(".result-count");
  const results = root.querySelector<HTMLElement>("#results");

  const renderResults = (): void => {
    if (!categoryFilter || !maxOverall || !sortBy || !resultCount || !results) {
      return;
    }

    const selectedCategory = categoryFilter.value;
    const selectedMaxOverall = Number(maxOverall.value);
    const selectedSort = sortBy.value as SortOption;

    const filtered = filterProducts(productData, selectedCategory, selectedMaxOverall);

    const sorted = sortProducts(filtered, selectedSort);

    writeStateToQuery({
      category: selectedCategory,
      maxOverall: maxOverall.value,
      sortBy: selectedSort
    });

    resultCount.textContent = `${sorted.length} Produkte angezeigt`;

    if (sorted.length === 0) {
      results.innerHTML = "<p class='empty-state'>Keine Produkte passen zu den aktuellen Filtern.</p>";
      return;
    }

    results.innerHTML = renderCards(sorted);
  };

  categoryFilter?.addEventListener("change", renderResults);
  maxOverall?.addEventListener("change", renderResults);
  sortBy?.addEventListener("change", renderResults);
  renderResults();
}